/**
 * Interface for tracing function executions in Improv
 */
export interface Tracer {
  /**
   * Trace a function execution
   * @param fn The function to trace
   * @param metadata Metadata about the trace
   * @returns The wrapped function that will be traced
   */
  traceable<T extends (...args: any[]) => any>(
    fn: T,
    metadata: TraceMetadata
  ): T;
}

/**
 * Metadata for a trace
 */
export interface TraceMetadata {
  /** The name of the trace */
  name: string;
  /** The type of run (e.g., "tool", "llm", "agent") */
  run_type?: string;
  /** Any additional metadata */
  [key: string]: unknown;
}

/**
 * A tracer that does nothing
 */
export class NullTracer implements Tracer {
  traceable<T extends (...args: any[]) => any>(fn: T, _metadata: TraceMetadata): T {
    // Simply returns the original function without any tracing
    return fn;
  }
}

// The default tracer does nothing
export const defaultTracer = new NullTracer(); 